var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { AddRowComponent } from '../addrow/addrow.component';
import { AddRowService, Item } from '../addrow/addrow.service';
var MultiUploadComponent = /** @class */ (function (_super) {
    __extends(MultiUploadComponent, _super);
    function MultiUploadComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.fileKey = '';
        _this.fileOptions = {};
        return _this;
    }
    MultiUploadComponent.prototype.ngOnChanges = function (changes) {
        if (changes.component) {
            this.getParams();
        }
        if (changes.parentCols) {
            this.cols = $.extend(true, [], this.parentCols);
            this.orgCols = $.extend(true, [], this.cols);
            this.setFileOptions();
            this.checkReadonly();
        }
        if (changes.parentItems) {
            this.onSubscribe(this.parentItems);
        }
    };
    MultiUploadComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setFileOptions();
    };
    MultiUploadComponent.prototype.getParams = function () {
        _super.prototype.getParams.call(this);
        var params = this.component.params;
        this.fileKey = params.fileKey || '';
        this.fileOptions = params.fileOptions || {};
    };
    MultiUploadComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        this.setFileOptions();
    };
    MultiUploadComponent.prototype.setFileOptions = function () {
        if (this.fileKey && this.fileOptions) {
            this.setFile(this.cols);
            this.orgCols = $.extend(true, [], this.cols);
        }
    };
    MultiUploadComponent.prototype.setFile = function (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (!col.items) {
                if (col.key === this.fileKey && col.controlType === 'file') {
                    col.controlType = 'fileInfo';
                    col.params = Object.assign({}, col.params || {}, this.fileOptions);
                }
            }
            else {
                this.setFile(col.items);
            }
        }
    };
    MultiUploadComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        this.dispItems = [];
        this.deleteItems = [];
        this.errItems = [];
        this.uniqueKeys = [];
        var items = [];
        if (typeof data[this.cols[0].key] !== 'undefined' && data[this.cols[0].key] instanceof Array) {
            items = data[this.cols[0].key];
        }
        this.seq = 1;
        var recs = [];
        var dispRecs = [];
        var deleteRecs = [];
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (typeof item[this.primaryKey] !== 'undefined' && typeof item.$type === 'undefined') {
                item.$type = "put" /* Put */;
            }
            this.rec = {};
            this.dispRec = {};
            _super.prototype.setRecs.call(this, this.cols[0].items, Object.assign(new Item(), { $seq: this.seq++ }, item));
            if (item.$type === "delete" /* Delete */) {
                deleteRecs.push(this.rec);
            }
            else {
                recs.push(this.rec);
                dispRecs.push(this.dispRec);
            }
        }
        this.items = recs;
        this.dispItems = dispRecs;
        this.deleteItems = deleteRecs;
        this.service.setUniqueKeys(this.componentName, this.uniqueKeys);
        this.setCompRec();
    };
    MultiUploadComponent.prototype.onChangeFile = function (e) {
        this.onEvent(null, 'add', null);
        var index = this.items.length - 1;
        for (var _i = 0, _a = Object.keys(e); _i < _a.length; _i++) {
            var key = _a[_i];
            this.onChangeRow({ key: key, val: e[key] }, index);
        }
    };
    MultiUploadComponent.prototype.setCompRec = function () {
        _super.prototype.setCompRec.call(this);
    };
    MultiUploadComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'multi-upload',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"cols?.length > 0\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"cols[0]\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd addrowDir></dd>\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li\">\n              <multi-upload-file *ngIf=\"fileKey && fileOptions && addable && !readonly && (maxRows === null || dispItems.length < maxRows)\"\n                                 [key]=\"'form'\"\n                                 [componentName]=\"componentName\"\n                                 [index]=\"seq\"\n                                 [col]=\"{key: fileKey, controlType: 'file', params: fileOptions}\"\n                                 [msg]=\"(msg | async)\"\n                                 (changeFile)=\"onChangeFile($event)\"></multi-upload-file>\n            </li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\" [class.-mt-1]=\"addable && !readonly && (maxRows === null || dispItems.length < maxRows)\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly || !sortKey\" scope=\"col\"></th>\n        <th [hidden]=\"readonly || !deletable\" scope=\"col\"></th>\n        <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n          <th *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" scope=\"col\">\n            <a a class=\"-fixed\">{{ col.label }}</a>\n          </th>\n        </ng-template>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"dispItems\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly || !sortKey\" class=\"tableWrapper_arrowTd\">\n            <ul class=\"stageFlow_arrows\">\n              <li><a *ngIf=\"index > 0\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li><a *ngIf=\"index < dispItems.length - 1\" href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n            </ul>\n          </td>\n          <td [hidden]=\"readonly || !deletable\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"item?.$editable\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <ng-template ngFor let-col [ngForOf]=\"cols[0].items\" [ngForTrackBy]=\"trackByCol\">\n            <td *ngIf=\"col.readonly || (!col.readonly && !col.hidden)\" [col]=\"col\" listDir>\n              <column [key]=\"'list'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                key: col.key,\n                controlType: col.controlType,\n                dataType: col.dataType,\n                required: col.required,\n                readonly: item.$editable ? col.readonly : true,\n                hidden: col.hidden,\n                params: col.params,\n                items: col.items\n              }\" [val]=\"item\" [msg]=\"(msg | async)\" [err]=\"errItems[index] || {}\" (setChangeVal)=\"onChangeRow($event, index)\" (clickCol)=\"onClickRow($event, index)\"></column>\n            </td>\n          </ng-template>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    MultiUploadComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AddRowService }
    ]; };
    return MultiUploadComponent;
}(AddRowComponent));
export { MultiUploadComponent };
//# sourceMappingURL=multi-upload.component.js.map